export default "__VITE_ASSET__BCGCAnkQ__"